package br.com.duoma.duomaproducao.ui.screens

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.expandHorizontally
import androidx.compose.animation.shrinkHorizontally
import androidx.compose.animation.shrinkOut
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.produceState
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.unit.dp


@Composable
fun AuthScreen(isLoading : Boolean, isFailure : Boolean, onLogin : (String) -> Unit) {
    var passwordText by remember { mutableStateOf("") }
    Box(Modifier.fillMaxSize().background(MaterialTheme.colorScheme.background), contentAlignment = Alignment.Center) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Text("Autenticar", style = MaterialTheme.typography.displayLarge)
            Spacer(Modifier.height(28.dp))
            OutlinedTextField(
                passwordText,
                onValueChange = { passwordText = it },
                label = { Text("Senha") },
                singleLine = true,
                modifier = Modifier.width(300.dp),
                keyboardActions = KeyboardActions(onDone = {onLogin(passwordText)}),
                visualTransformation = remember {PasswordVisualTransformation()},
                isError = isFailure
            )
            Spacer(Modifier.height(14.dp))
            Button(
                {onLogin(passwordText)},
                Modifier.width(300.dp),
            ) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    AnimatedVisibility(isLoading,
                        enter = expandHorizontally { 0 },
                        exit = shrinkHorizontally { 0 }
                        ) {
                        CircularProgressIndicator(Modifier.size(12.dp), color = Color.White)
                        Spacer(Modifier.width(12.dp))
                    }
                    Text("Logar")
                }
            }
        }
    }
}